const actions = {
  LOGIN_FINISHED: 'LOGIN_FINISHED',
  FETCH_ACCOUNTS: 'FETCH_ACCOUNTS',
  SWITCH_ACCOUNT: 'SWITCH_ACCOUNT',
  FETCH_ACCOUNTS_SUCCESS: 'FETCH_ACCOUNTS_SUCCESS',
  SELECT_ACCOUNT: 'SELECT_ACCOUNT',
  SELECT_ACCOUNT_SUCCESS: 'SELECT_ACCOUNT_SUCCESS',
  ADD_ACCOUNT: 'ADD_ACCOUNT',
  ADD_ACCOUNT_SUCCESS: 'ADD_ACCOUNT_SUCCESS',
  ADD_ACCOUNT_ERROR: 'ADD_ACCOUNT_ERROR',
  addAccount: (account) => ({
    type: actions.ADD_ACCOUNT,
    account,
  }),
  addAccountSuccess: (account) => ({
    type: actions.ADD_ACCOUNT_SUCCESS,
    account,
  }),
  addAccountError: (account) => ({
    type: actions.ADD_ACCOUNT_ERROR,
  }),
  fetchAccounts: () => ({
    type: actions.FETCH_ACCOUNTS
  }),
  fetchAccountsSuccess: (accounts) => ({
    type: actions.FETCH_ACCOUNTS_SUCCESS,
    accounts: accounts,
  }),
  selectAccount: (accountId) => ({
    type: actions.SELECT_ACCOUNT,
    accountId: accountId
  }),
  selectAccountSuccess: (account) => ({
    type: actions.SELECT_ACCOUNT_SUCCESS,
    account: account
  }),
  switchAccount: (accountId) => ({
    type: actions.SWITCH_ACCOUNT,
    accountId: accountId
  })
};
export default actions;
